import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../shared/SectionHeader';
import '../../styles/landing/InstallmentHighlightSection.css';

const InstallmentHighlightSection: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section
            className="landing-section landing-section--navy installment-highlight"
            aria-labelledby="installments-heading"
        >
            <div className="landing-container">
                <SectionHeader
                    title={t('installments.title')}
                    subtitle={t('installments.subtitle')}
                    id="installments-heading"
                />
                <div className="installment-highlight__card">
                    <h3 className="installment-highlight__example-title">
                        {t('installments.exampleTitle')}
                    </h3>
                    <dl className="installment-highlight__rows">
                        <div className="installment-highlight__row">
                            <dt>{t('installments.giftAmount')}</dt>
                            <dd><span className="ltr-value">₪1,200</span></dd>
                        </div>
                        <div className="installment-highlight__row">
                            <dt>{t('installments.paymentPlan')}</dt>
                            <dd>{t('installments.monthlyPayments', { count: 6 })}</dd>
                        </div>
                        <div className="installment-highlight__row installment-highlight__row--accent">
                            <dt>{t('installments.guestPays')}</dt>
                            <dd>
                                <span className="ltr-value">{t('installments.perMonth', { amount: '₪200' })}</span>
                            </dd>
                        </div>
                    </dl>
                    <p className="installment-highlight__disclaimer">{t('installments.disclaimer')}</p>
                </div>
            </div>
        </section>
    );
};

export default InstallmentHighlightSection;
